import React from "react";

const overview = [
  {
    icon: <i class="fa fa-shield"></i>,
    heading: "Cybersecurity",
    description:
      "An IT company can provide cybersecurity solutions to help real estate agencies to protect their data and systems from cyber threats, such as hacking and data breaches.",
  },
  {
    icon: <i class="fa fa-line-chart"></i>,
    heading: "Automation & Efficiency",
    description:
      "An IT company can develop software solutions to automate many of the repetitive and time-consuming tasks involved in real estate sales, which will improve efficiency.",
  },
  {
    icon: <i class="fa fa-database"></i>,
    heading: "Data Analytics",
    description:
      "An IT company can provide tools for data analysis that can help real estate agencies to better understand market trends, customer behavior, and property performance.",
  },
  {
    icon: <i class="fa fa-facebook"></i>,
    heading: "Digital Marketing",
    description:
      " An IT company can help real estate agencies to reach a wider audience through digital marketing channels such as social media, seo, and email marketing.",
  },
];

class Overview extends React.Component {
  render() {
    return (
      <>
        <div className="section-full  mobile-page-padding p-b10 bg-repeat">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="mb__25 bg-white">
                  <h2 class="ert678">Overview</h2>
                  <p className="mb__15">
                    Partnering with an IT company can provide several advantages
                    to a real estate agency. By leveraging technology and
                    digital solutions, real estate agency can enhance themselves
                    and provide better services to their customers. Here are
                    some potential benefits :
                  </p>
                </div>
              </div>
              {overview.map((item, index) => (
                <div className="col-lg-3 col-md-6" key={index}>
                  <div class="card-wrap mt__0">
                    <div class="card-header three">{item.icon}</div>
                    <div class="card-content">
                      <h3 class="card-title">{item.heading}</h3>
                      <p class="card-text">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Overview;
